import {integrityProfCollaborator} from 'constants/url';
import useLoad from '../../../components/hooks/useLoad';

function useIntegrityProfCollaborator(selection: any) {
  return useLoad(integrityProfCollaborator, 'revision', selection);
}

export default useIntegrityProfCollaborator;
